import { Text, View } from '@react-pdf/renderer';

import { Contract } from '@/types/ContractType';
import { styles } from '../style';

const SettlementAndPossession = ({ contract }: { contract: Contract }) => (
  <View style={styles.section}>
    <Text style={styles.title}>SETTLEMENT AND POSSESSION</Text>
    <Text style={styles.text}>
      1. The Settlement Date is on{' '}
      <Text style={styles.DangerText}>
        {contract?.offerSpecifics.closingDate || 'Not specified'}
      </Text>{' '}
      or before if Buyer and Seller agree.
    </Text>

    <Text style={styles.text}>
      2. Settlement will occur in the county where the Property is located or in
      an adjacent county, during normal business hours, unless Buyer and Seller
      agree otherwise.
    </Text>

    <Text style={styles.text}>
      3. At time of settlement, the following will be pro-rated on a daily basis
      between Buyer and Seller, reimbursing where applicable: Current Taxes,
      rents; interest on mortgage assumptions; condominium fees and homeowner
      association fees; water and/or sewer fees, together with any other
      lienable municipal service fees. All charges will be prorated for the
      period(s) covered. Seller will pay up to and including the date of
      settlement and Buyer will pay for all days following settlement, unless
      otherwise stated here.
    </Text>

    <Text style={styles.text}>
      4. For purposes of prorating real estate taxes, the Seller made the most
      recent tax payment:{' '}
      <Text style={styles.DangerText}>
        {contract?.sellerPropertyInfo?.taxDate || 'Not specified'}
      </Text>
    </Text>

    <Text style={styles.text}>
      5. For purposes of marketable title, the seller's mortgage company is:{' '}
      <Text style={styles.bold}>
        {contract?.sellerPropertyInfo?.mortgageCompany || 'Not specified'}
      </Text>
    </Text>

    <Text style={styles.text}>
      6. For purposes of Seller closing documentation signing, the seller's
      elects as their escrow agent is:{' '}
      <Text style={styles.bold}>
        {contract?.sellerPropertyInfo?.escrowAgent || 'Not specified'}
      </Text>
    </Text>

    <Text style={styles.text}>
      7. Conveyance from Seller will be by fee simple deed of special warranty
      unless otherwise stated.
    </Text>

    <Text style={styles.text}>
      8. Seller will pay all transfer taxes and or document stamp taxes.
    </Text>

    <Text style={styles.text}>
      9. Possession is to be delivered by deed, existing keys and physical
      possession to a vacant Property free of debris, with all structures
      broom-clean, at day and time of settlement.
    </Text>

    <Text style={styles.text}>
      10. Buyer shall pay the Purchase Price in cash at date and time of
      settlement.
    </Text>
  </View>
);

export default SettlementAndPossession;
